const replaceMap = {
    '-': '&#8211;',
}

export const widowRemover = (string = '') => {
    const result = string
        .split(' ')
        .map(word => replaceMap[word] || word)
        .reduce(
            (result, word) =>
                word.length > 3
                    ? `${result}${word} `
                    : `${result}${word}&nbsp;`,
            ''
        )

    return { __html: result }
}

export default (string = '') => ({
    __html: string,
})



// WEBPACK FOOTER //
// ./src/utils/prettyText.js